export const COLOR_BLACK = '0, 0, 0'
export const COLOR_WHITE = '255, 255, 255'
export const COLOR_RED = '220, 53, 69'
export const COLOR_GREEN = '40, 167, 69'
export const COLOR_BLUE = '0, 123, 255'

export const COLOR_MARKER = COLOR_GREEN
export const COLOR_MARKER_LINE = COLOR_WHITE
export const COLOR_PROTO_DEFAULT = COLOR_BLACK
export const COLOR_PROTO_TCP = COLOR_GREEN
export const COLOR_PROTO_UDP = COLOR_BLUE
export const COLOR_PROTO_UNKNOWN = COLOR_RED
